import React, { memo } from 'react';
import { Card, CircularProgress, Stack, Typography } from 'investira.react.components';

const AvaliacoesGestorEditLoadingView = memo(() => {
  return (
    <Card sx={{ p: 4 }}>
      <Stack alignItems="center" justifyContent="center" gap={1.5} sx={{ minHeight: 240 }}>
        <CircularProgress />
        <Typography variant="body2" color="textSecondary" sx={{ textAlign: 'center' }}>
          Carregando avaliação.
        </Typography>
      </Stack>
    </Card>
  );
});

export default AvaliacoesGestorEditLoadingView;
